import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, ViewChild  } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule, Table } from 'primeng/table';
import { RouterLink, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

import { AuthService } from '../../../../services/auth.service';
import { PageTitleService } from '../../../../services/pagetitle.service';
import { AssociatesManagementService } from '../../../../services/associates-management.service';
import { EncryptionService } from '../../../../services/encryption.service';
import { Base64UrlService } from '../../../../services/base64-url.service';
import { HttpClient } from '@angular/common/http';

/*----Prime NG----*/
import { InputTextModule } from 'primeng/inputtext';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';

@Component({
  selector: 'app-associate-management',
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonModule, TableModule, InputTextModule, InputIconModule, IconFieldModule, FormsModule],
  providers: [Base64UrlService],
  templateUrl: './associate-management.component.html',
  styleUrl: './associate-management.component.css'
})
export class AssociateManagementComponent {
  @ViewChild('dt2') dt2: any;
  userName: any;
  lang: any;
  associatesList: any[] = [];
  userType: any = 1;
  selectStatus: any = -1;
  userCode: any;
  // These hold filtered data
  visibleData: any[] = [];
  totalCount: number = 0;
  dashboard_msg: string | null = null;
  msgType: any;
  isVisible: boolean = true;

  constructor(private auth: AuthService, private translate: TranslateService, private ams: AssociatesManagementService, private en: EncryptionService, private pageTitle: PageTitleService, private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {

      this.lang = (localStorage.getItem('site_lang') ? localStorage.getItem('site_lang') : 'en');
      // console.log(this.lang)
      translate.use(this.lang);
    }
  }

  ngOnInit() {
    this.userName = this.auth.getName();
    this.userCode = this.auth.getCode();
    this.pageTitle.setTitle('menu.management');
    if (isPlatformBrowser(this.platformId)) {
      this.getAssociatesList();
    }
  }

  ngAfterViewInit() {
    // Initially set to full dataset
    // this.filteredData = [...this.associatesList];
    setTimeout(() => this.updateVisibleData(), 0);
  }

  getAssociatesList() {
    this.ams.getAssociates(this.selectStatus, this.userType)
      .subscribe({
        next: (res: any) => {
          // this.associatesList = res.data;
          this.associatesList = res.data.map((row: any) => ({
            ...row,            
            showResetBtn: true   // Add this flag
          }));
          this.totalCount = this.associatesList.length;
          // console.log(this.associatesList);
        },
        error: (err: any) => {
          console.log(err);
          if (err.status == 401) {
            this.auth.logout();
			return
          }
        }
      });
  }

  searchAssociates() {
    // console.log(); 
    // this.selectStatus
    this.getAssociatesList();
  }

  clearAll() {
    this.userType = 1;
    this.selectStatus = -1;
    this.getAssociatesList();
  }
  applyFilterGlobal($event: Event) {
    const input = $event.target as HTMLInputElement;
    this.dt2.filterGlobal(input.value, 'contains');
    // Table triggers onFilter after this
  }

  // Update filteredData whenever filter or pagination changes
  onFilter(event: any) {
    this.updateVisibleData();
  }
  onPage(event: any) {
    this.updateVisibleData(event);
  }

  updateVisibleData(event?: any) {
    const filtered = this.dt2?.filteredValue ?? this.associatesList ?? [];
    const start = event?.first ?? this.dt2?.first ?? 0;
    const rows = event?.rows ?? this.dt2?.rows ?? 3;
    const end = start + rows;
    this.visibleData = filtered.slice(start, end);
  }

  onGlobalFilter(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.dt2.filterGlobal(value, 'contains');
  }

  cngStatus(event: any, userId: any) {
    const input = event.target as HTMLInputElement;
    const isChecked = input.checked;
    let flag = true;
    if (!isChecked) {
      console.log(userId);
      flag = false;
    }
    const payLoad = {
      "userId": userId,
      "enabled": flag
    }
    // console.log(payLoad);
    this.ams.updateStatus(payLoad)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            this.dashboard_msg = res.message;//"dataSaveSuccesMessage";
            this.msgType = "success";
            this.getAssociatesList();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          } else {
            this.dashboard_msg = res.message;//"dataSaveErrorMessage";
            this.msgType = "danger";
            this.getAssociatesList();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        },
        error: (err: any) => {
          console.log(err);
          if (err.status == 401) {
            this.auth.logout();
			      return
          } else {

          }
        }
      });
  }

  reset() {
    this.dashboard_msg = null;
  }

  restPassword(item: any) { 
    if (!item.userId) {
      this.dashboard_msg = "dataRetriveErrorMessage";
      this.msgType = "danger";
      this.getAssociatesList();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    const payLoad = {
      "userId": item.userId,
      "allowReset": true
    }
    
    this.ams.restPasswordDb(payLoad)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            this.dashboard_msg = res.message;//"dataSaveSuccesMessage";
            this.msgType = "success";
            // this.isVisible = false;
            item.showResetBtn = false;
            // item.isPasswordReset = false;
            this.getAssociatesList();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          } else {
            this.dashboard_msg = res.message;//"dataSaveErrorMessage";
            this.msgType = "danger";
            this.getAssociatesList();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        },
        error: (err: any) => {
          if (err.status == 401) {
            this.auth.logout()
            return;
          }
          this.dashboard_msg = "dataSaveErrorMessage";
            this.msgType = "danger";
            this.getAssociatesList();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    })
  }
}
